"use client"

import { TicketPlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TicketPlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TicketPlusIcon = component(Icon)({ as: TicketPlus })
